<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item to="/template/list">组合购管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加组合购</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">状态：</span>
            <el-switch
              v-model="dataForm.status"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="margin-top: 20px;"
    >
      <h3 class="title">添加组合购</h3>

      <div class="main">

        <div class="form">
          <el-form
            class="search-wrap"
            ref="formRules"
            :model="dataForm"
            :rules="rules"
            label-width="100px"
            label-position="right"
          >
            <el-form-item
              label="名称："
              prop="name"
            >
              <el-input
                v-model="dataForm.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="描述："
              prop="description"
            >
              <el-input
                v-model="dataForm.description"
                placeholder="请输入描述"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="选择产品："
              prop="count"
            >

              <div
                class="product_all_div"
                v-for="(item,index) in product_all"
                :key="index"
              >
                <div class="pruduct_all_item">
                  <div><span>商品名称：{{item.name}}</span></div>
                  <div
                    class="pruduct_all_properties"
                    v-for="(pitem,pindex) in item.properties"
                    :key="pindex"
                  ><span>规格（{{pitem.name}}）：{{pitem.values.map((v)=>{ return v.name }).join(',')}}</span></div>
                  <div class="pruduct_all_remove">
                    <img
                      src="@/assets/img/cancel_icon.png"
                      alt=""
                      srcset=""
                      @click="handleRemove(index)"
                    >
                  </div>
                </div>
                <el-table
                  v-if="item.skus.length"
                  :data="item.skus"
                  size="mini"
                  style="width: 100%;margin-top:16px;"
                >
                  <el-table-column
                    show-overflow-tooltip
                    width="80"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-checkbox v-model="scope.row.isChecked"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="规格"
                    class="skus_table"
                    show-overflow-tooltip
                    width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span class="skus_table_span">{{scope.row.properties.map((v)=>{ return v.val }).join(',')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="原价"
                    class="skus_table"
                    show-overflow-tooltip
                    width="100"
                    align="center"
                    prop="price"
                  >
                  </el-table-column>
                  <el-table-column
                    label="优惠价"
                    show-overflow-tooltip
                    align="left"
                    prop="price"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.now_price"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        placeholder="请输入"
                        style="width:120px;"
                        v-if="scope.row.isChecked"
                        @input="computedTotal"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="list-wrap">
                <div class="item-empty">
                  <div class="empty-content">
                    <el-link
                      type="primary"
                      :underline="false"
                      @click="openChooseGoods()"
                    >选择商品
                    </el-link>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="组合总价："
              prop="total"
            >
              <el-input
                v-model="dataForm.total"
                placeholder="请输入描述"
                readonly
                style="width: 100px;"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="有效期："
              prop="time"
            >

              <el-date-picker
                v-model="dataForm.time"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="排序值："
              prop="sort"
            >
              <el-input
                v-model="dataForm.sort"
                placeholder="请输入排序值，纯数字"
                style="width: 100px"
                oninput="value=value.replace(/[^0-9.]/g,'')"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="line"></div>
          <div class="btn-wrap">
            <el-button
              type="primary"
              @click="submit('formRules')"
            >添加</el-button>
            <el-button @click="handleClose()">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <GoodsTabsChooseJoint
      :visible="goodsChooseDialog"
      type="single"
      @submit="saveGoods"
      @close="goodsChooseDialog = false"
      :isAll="1"
      :products="product_all"
    />
  </div>
</template>
  <script>
import GoodsTabsChooseJoint from "@/components/dialog/product/GoodsTabsChooseJoint";
import { productOne } from "@/api/product";
import { editBucketCourse, bucketCourseOne, } from "@/api/operation";


export default {
  components: {
    GoodsTabsChooseJoint
  },
  data() {
    return {
      dataForm: {
        status: 1,
        total: 0,
        sort: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        time: [{ required: true, message: "请输入有效期", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序值", trigger: "blur" }],
        count: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.product_all.length) {
              callback(new Error('请选择商品'))
            } else if (this.product_all.findIndex(v => {
              return v.skus.findIndex(t => {
                return t.isChecked && !t.now_price
              }) != -1
            }) != -1) {
              callback(new Error('请输入优惠价'))
            } else {
              callback()
            }
          },
        }],
        total: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.dataForm.total) {
              callback(new Error('请输入商品优惠价'))
            } else {
              callback()
            }
          },
        }],
      },
      goodsChooseDialog: false,
      product_all: [],
      total: 0,

    };
  },
  created() {
    this.fetchDetail()
  },

  methods: {
    fetchDetail() {
      bucketCourseOne({ id: this.$route.params.id }).then((res) => {
        this.dataForm = {
          name: res.name,
          description: res.description,
          sort: res.sort,
          status: res.status
        }
        this.$set(this.dataForm, "time", [
          res.start_time,
          res.end_time,
        ]);
        this.product_all = res.products
        this.product_all.forEach(item => {
          this.$set(item, 'skus', item.skus_bucket_course)
          item.skus.forEach((items) => {
            if (item.skus.length == 1) {
              let arr = [{ val: '无规格' }]
              this.$set(items, 'properties', arr)
            }
            this.$set(items, 'now_price', items.bucket_course_price)
            this.$set(items, 'isChecked', items.active_status == 1 ? true : false,)
          })
        })
        this.computedTotal()
      });
    },
    computedTotal() {
      let num = this.product_all.reduce((acc, cur) => {
        return acc + Number(cur.skus.reduce((acc_o, cur_o) => {
          return acc_o + Number(cur_o.isChecked ? cur_o.now_price : 0)
        }, 0))
      }, 0)
      this.$set(this.dataForm, 'total', Number(num.toFixed(2)))
    },
    handleClose() {
      this.$router.go(-1)
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let arr = []
          this.product_all.forEach(item => {
            item.skus.forEach(citem => {
              if (citem.isChecked) {
                arr.push({
                  product_id: item.id,
                  sku_id: citem.id ? citem.id : null,
                  price: Number(citem.now_price),
                  active_status: 1
                })
              }
            })
          })
          let params = {
            id: this.$route.params.id,
            name: this.dataForm.name,
            description: this.dataForm.description,
            sort: this.dataForm.sort,
            status: this.dataForm.status,
            start_time: this.dataForm.time[0],
            end_time: this.dataForm.time[1],
            product_count: this.product_all.length,
            product_ids: this.product_all.map(v => {
              return v.id
            }).join(','),
            prices: arr
          }
          editBucketCourse(params).then((res) => {
            if (res == null) {
              this.handleClose()
              this.$message.success('修改成功')
            }
          })
        } else {

          console.log("error submit!!");
          return false;
        }
      });
    },
    openChooseGoods() {
      this.goodsChooseDialog = true
    },
    handleRemove(index) {
      this.product_all.splice(index, 1)
    },
    saveGoods(product) {
      if (product) {
        this.product = product;
        // 商品详情查询
        this.fetchProductInfo();
      }
    },
    // 商品详情查询
    fetchProductInfo() {
      productOne({ id: this.product.id }).then((res) => {
        if (res) {
          let obj = Object.assign({}, res)
          if (!obj.skus.length) {
            obj.skus.push({
              id: null,
              properties: [{ val: '无规格' }],
              price: obj.price
            })
            this.product_all.push(obj)

          } else {
            this.product_all.push(obj)
          }

          /*     if (res.skus.length) {
                this.product_all.push(res)
              } else {
                res.skus.push({
                  id: null,
                  properties: [{ val: '无规格' }],
                  price: res.price
                })
                this.product_all.push(res)
                console.log(this.product_all);
              } */
        }

      });
    },
  },
};
      </script>
      
      <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 20px;
    .main {
      display: flex;
      padding-top: 24px;

      .form {
        flex: 1;
        .link-wrap {
          margin-top: 8px;
          font-size: 14px;
          color: #999;
          .el-link {
            margin-right: 16px;
          }
        }
        .line {
          width: 730px;
          height: 1px;
          background: #eeeeee;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
        }
        .btn-wrap {
          margin-top: 16px;
        }
        .check {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          .el-link {
            margin-right: 12px;
          }
          .el-tag {
            margin: 0px 8px;
            margin-bottom: 8px;
          }
        }
        .tips {
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }
      .preview {
        flex: 1;
        display: flex;
        justify-content: center;
        .preview-content {
          width: 330px;
          height: 546px;
          background-image: url("https://upload.kaoyanbox.net/5b02efcfefeb534cae1ffe1ab8a88da0.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .pop {
            width: 224px;
            background: #e9e9eb;
            opacity: 1;
            min-height: 80px;
            border-radius: 16px;
            margin-top: 118px;
            padding: 9px 12px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-left: 43px;
            span {
              word-wrap: break-word;
            }
          }
          .tips {
            width: 261px;
            margin: 0 auto;
            margin-top: 40px;
            padding: 9px 12px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            span {
              color: #e34d59;
              margin: 0px 4px;
            }
          }
        }
      }
    }
    .list-wrap {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      .item-empty {
        padding: 8px;
        border-radius: 4px;
        opacity: 1;
        border: 1px solid #dcdfe6;
        margin-bottom: 16px;
        .empty-content {
          padding: 10px 16px;
          background: #f5f5f5;
          border-radius: 2px;
          opacity: 1;
        }
      }
    }
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
}
/deep/.el-alert__icon {
  color: #266fe8;
}
/deep/.el-alert__title {
  color: #333;
}
.product_all_div {
  .pruduct_all_item {
    background: #f5f5f5;
    height: 45px;
    display: flex;
    align-items: center;
    padding: 0px 10px;
    position: relative;
    margin-top: 16px;
    .pruduct_all_properties {
      margin: 0 16px;
      font-size: 14px;
    }
    .pruduct_all_remove {
      position: absolute;
      top: 10px;
      right: 16px;
      width: 16px;
      height: 16px;
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
    span {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      opacity: 1;
    }
  }
  .skus_table {
    .skus_table_span {
      font-size: 10px;
      border: solid;
    }
  }
}
</style>
      